// extracted by mini-css-extract-plugin
export default {"statCard":"StatCard_statCard__w07E3","statLabel":"StatCard_statLabel__ihAt5","statValue":"StatCard_statValue__NcXqx"};